export default {"src":"/_next/static/media/about_01.8d0820e5.svg","height":213,"width":282,"blurWidth":0,"blurHeight":0};